import { ethers } from 'ethers';
import Web3Modal from 'web3modal';
import WalletConnectProvider from '@walletconnect/web3-provider';

// Fee constants - removed payment requirements
export const LOCK_FEE_USD = 0;
export const UNLOCK_FEE_USD = 0;
export const PROFIT_FEE_PERCENTAGE = 0; // No fees

// Platform fee wallet addresses
export const PLATFORM_FEE_WALLET_ETH = "0xf686507C4EF14C65148d4eCA6371Db72B957F71c"; // Your Ethereum wallet
export const PLATFORM_FEE_WALLET_BSC = "0xf686507C4EF14C65148d4eCA6371Db72B957F71c"; // Your BSC wallet (same address)


// Developer fee wallet addresses
export const DEVELOPER_FEE_WALLET_ETH = "0x512D422791eed5626bB57E07f41c467950f82910"; // Developer Ethereum wallet
export const DEVELOPER_FEE_WALLET_BSC = "0x512D422791eed5626bB57E07f41c467950f82910"; // Developer BSC wallet (same address)

// Fee percentages
export const PLATFORM_FEE_PERCENTAGE = 15; // 15% platform fee
export const DEVELOPER_FEE_PERCENTAGE = 4; // 4% developer fee
export const USER_RECEIVES_PERCENTAGE = 81; // 81% user receives (100% - 15% - 4%)

// Contract addresses
export const ETH_CONTRACT_ADDRESS = "0xaA64090345e364a33Bd1F9694C2fce665F9bd41F";
export const BSC_CONTRACT_ADDRESS = "0xb7B7aEBccEfDca5eA9a72623E758C17B03030601";

// API Keys
export const ALCHEMY_API_KEY = "Cw3mjOFn10QIYAcUHOofB1qvAzyYXBDG";
export const BSCSCAN_API_KEY = "7Z72QRR7KR58VKTHE3H44DIDC14EBUV91V";
export const INFURA_API_KEY = "431bc747c7ca4f2db0fcea6abe1dc3b9";

// Contract ABI
export const ABI = [
  {
    "anonymous": false,
    "inputs": [
      { "indexed": false, "internalType": "uint256", "name": "lockId", "type": "uint256" },
      { "indexed": true, "internalType": "address", "name": "token", "type": "address" },
      { "indexed": true, "internalType": "address", "name": "owner", "type": "address" },
      { "indexed": false, "internalType": "uint256", "name": "amount", "type": "uint256" },
      { "indexed": false, "internalType": "uint256", "name": "unlockTime", "type": "uint256" }
    ],
    "name": "Locked",
    "type": "event"
  },
  {
    "inputs": [
      { "internalType": "address", "name": "token", "type": "address" },
      { "internalType": "uint256", "name": "amount", "type": "uint256" },
      { "internalType": "uint256", "name": "unlockTime", "type": "uint256" }
    ],
    "name": "lockTokens",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": false, "internalType": "uint256", "name": "lockId", "type": "uint256" },
      { "indexed": true, "internalType": "address", "name": "owner", "type": "address" }
    ],
    "name": "Unlocked",
    "type": "event"
  },
  {
    "inputs": [
      { "internalType": "uint256", "name": "lockId", "type": "uint256" }
    ],
    "name": "unlockTokens",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint256", "name": "lockId", "type": "uint256" }
    ],
    "name": "getLock",
    "outputs": [
      { "internalType": "address", "name": "", "type": "address" },
      { "internalType": "uint256", "name": "", "type": "uint256" },
      { "internalType": "uint256", "name": "", "type": "uint256" },
      { "internalType": "address", "name": "", "type": "address" },
      { "internalType": "bool", "name": "", "type": "bool" }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "lockCount",
    "outputs": [
      { "internalType": "uint256", "name": "", "type": "uint256" }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint256", "name": "", "type": "uint256" }
    ],
    "name": "locks",
    "outputs": [
      { "internalType": "address", "name": "token", "type": "address" },
      { "internalType": "uint256", "name": "amount", "type": "uint256" },
      { "internalType": "uint256", "name": "unlockTime", "type": "uint256" },
      { "internalType": "address", "name": "owner", "type": "address" },
      { "internalType": "bool", "name": "withdrawn", "type": "bool" }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getFees",
    "outputs": [
      { "internalType": "uint256", "name": "lockFee", "type": "uint256" },
      { "internalType": "uint256", "name": "unlockFee", "type": "uint256" }
    ],
    "stateMutability": "view",
    "type": "function"
  }
];

// Minimal ERC-20 ABI for common functions needed
export const MINIMAL_ERC20_ABI = [
  "function balanceOf(address account) view returns (uint256)",
  "function approve(address spender, uint256 amount) public returns (bool)",
  "function allowance(address owner, address spender) view returns (uint256)",
  "function decimals() view returns (uint8)",
  "function symbol() view returns (string)",
  "function name() view returns (string)"
];

// Popular tokens configuration
export const POPULAR_TOKENS = {
  bsc: [
    { symbol: 'BNB', address: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c', name: 'Wrapped BNB' },
    { symbol: 'BUSD', address: '0xe9e7CEA3DeddAe1747ad215De46CD0DfEf4b4f9', name: 'Binance USD' },
    { symbol: 'USDT', address: '0x55d398326f99059ff775485246999027b3197955', name: 'Tether USD' },
    { symbol: 'USDC', address: '0x8AC76a51Cc950d9822D68b83fE1Ad97Ed32cDmo', name: 'USD Coin' },
  ],
  ethereum: [
    { symbol: 'ETH', address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2', name: 'Wrapped ETH' },
    { symbol: 'USDC', address: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48', name: 'USD Coin' },
    { symbol: 'USDT', address: '0xdAC17F958D2ee523a2206206994597C13D831ec7', name: 'Tether USD' },
  ]
};

// Network configuration
export const NETWORKS = {
  bsc: {
    chainId: 56,
    name: 'BNB Smart Chain',
    rpcUrl: 'https://bsc-dataseed.bnbchain.org',
    contractAddress: BSC_CONTRACT_ADDRESS,
    blockExplorer: 'https://bscscan.com',
    alchemyBaseUrl: `https://bsc-mainnet.g.alchemy.com/v2/${ALCHEMY_API_KEY}`,
  },
  ethereum: {
    chainId: 1,
    name: 'Ethereum',
    rpcUrl: `https://mainnet.infura.io/v3/${INFURA_API_KEY}`,
    contractAddress: ETH_CONTRACT_ADDRESS,
    blockExplorer: 'https://etherscan.io',
    alchemyBaseUrl: `https://eth-mainnet.g.alchemy.com/v2/${ALCHEMY_API_KEY}`,
  }
};

// Web3Modal provider options
export const providerOptions = {
  walletconnect: {
    package: WalletConnectProvider,
    options: {
      rpc: {
        1: `https://mainnet.infura.io/v3/${INFURA_API_KEY}`,
        56: 'https://bsc-dataseed.bnbchain.org',
      },
      network: 'binance',
      chainId: 56,
    },
  },
};

// Web3Modal instance
export const web3Modal = new Web3Modal({
  cacheProvider: true,
  providerOptions,
  disableInjectedProvider: false,
});

// Network switching function with enhanced reliability
export const switchNetwork = async (provider, chainId) => {
  try {
    // First try to switch to the network
    try {
      await provider.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: `0x${chainId.toString(16)}` }],
      });
      
      // Wait for the switch to complete
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Verify the switch was successful
      const network = await provider.request({ method: 'eth_chainId' });
      const currentChainId = parseInt(network, 16);
      
      if (currentChainId !== chainId) {
        throw new Error('Network switch verification failed');
      }
      
      return true;
    } catch (switchError) {
      // If the network doesn't exist, add it
      if (switchError.code === 4902) {
        const networkConfig = chainId === 56 ? {
          chainId: `0x${chainId.toString(16)}`,
          chainName: 'BNB Smart Chain',
          nativeCurrency: {
            name: 'BNB',
            symbol: 'BNB',
            decimals: 18
          },
          rpcUrls: ['https://bsc-dataseed.bnbchain.org'],
          blockExplorerUrls: ['https://bscscan.com']
        } : {
          chainId: `0x${chainId.toString(16)}`,
          chainName: 'Ethereum',
          nativeCurrency: {
            name: 'Ether',
            symbol: 'ETH',
            decimals: 18
          },
          rpcUrls: [`https://mainnet.infura.io/v3/${INFURA_API_KEY}`],
          blockExplorerUrls: ['https://etherscan.io']
        };
        
        try {
          await provider.request({
            method: 'wallet_addEthereumChain',
            params: [networkConfig],
          });
          
          // Wait for the network to be added and switched
          await new Promise(resolve => setTimeout(resolve, 2000));
          
          // Verify the switch was successful
          const network = await provider.request({ method: 'eth_chainId' });
          const currentChainId = parseInt(network, 16);
          
          if (currentChainId !== chainId) {
            throw new Error('Network addition and switch verification failed');
          }
          
          return true;
        } catch (addError) {
          console.error('Failed to add network:', addError);
          throw new Error(`Failed to add ${chainId === 56 ? 'BNB Smart Chain' : 'Ethereum'} network to your wallet. Please add it manually.`);
        }
      } else {
        console.error('Network switch error:', switchError);
        throw new Error(`Failed to switch to ${chainId === 56 ? 'BNB Smart Chain' : 'Ethereum'}. Please try again.`);
      }
    }
  } catch (error) {
    console.error('Network switching failed:', error);
    throw error;
  }
};

// Enhanced provider creation with fallback
export const createProvider = async (networkKey) => {
  const networkConfig = NETWORKS[networkKey];
  
  try {
    // Try to use injected provider first
    if (window.ethereum) {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const network = await provider.getNetwork();
      
      if (network.chainId === networkConfig.chainId) {
        return provider;
      }
    }
    
    // Fallback to RPC provider
    return new ethers.providers.JsonRpcProvider(networkConfig.rpcUrl);
  } catch (error) {
    console.error('Provider creation failed:', error);
    // Final fallback to RPC provider
    return new ethers.providers.JsonRpcProvider(networkConfig.rpcUrl);
  }
};

// Enhanced contract creation with retry mechanism
export const createContract = async (networkKey, signer = null) => {
  const networkConfig = NETWORKS[networkKey];
  const maxRetries = 3;
  let lastError;
  
  for (let i = 0; i < maxRetries; i++) {
    try {
      const provider = signer ? signer.provider : await createProvider(networkKey);
      const contractSigner = signer || provider.getSigner();
      
      const contract = new ethers.Contract(networkConfig.contractAddress, ABI, contractSigner);
      
      // Test the contract by calling a simple view function
      await contract.lockCount();
      
      return contract;
    } catch (error) {
      console.error(`Contract creation attempt ${i + 1} failed:`, error);
      lastError = error;
      
      if (i < maxRetries - 1) {
        // Wait before retrying
        await new Promise(resolve => setTimeout(resolve, 1000 * (i + 1)));
      }
    }
  }
  
  throw new Error(`Failed to create contract after ${maxRetries} attempts: ${lastError.message}`);
};

// Enhanced data fetching with retry mechanism
export const fetchWithRetry = async (fetchFunction, maxRetries = 3, delay = 1000) => {
  let lastError;
  
  for (let i = 0; i < maxRetries; i++) {
    try {
      return await fetchFunction();
    } catch (error) {
      console.error(`Fetch attempt ${i + 1} failed:`, error);
      lastError = error;
      
      if (i < maxRetries - 1) {
        // Exponential backoff
        await new Promise(resolve => setTimeout(resolve, delay * Math.pow(2, i)));
      }
    }
  }
  
  throw lastError;
};

// Enhanced token data fetching with caching
const tokenCache = new Map();
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

export const getCachedTokenData = (address, network) => {
  const key = `${address}-${network}`;
  const cached = tokenCache.get(key);
  
  if (cached && Date.now() - cached.timestamp < CACHE_DURATION) {
    return cached.data;
  }
  
  return null;
};

export const setCachedTokenData = (address, network, data) => {
  const key = `${address}-${network}`;
  tokenCache.set(key, {
    data,
    timestamp: Date.now()
  });
};

// Enhanced token symbol fetching
export const fetchTokenSymbol = async (address, provider, network) => {
  try {
    // Check cache first
    const cached = getCachedTokenData(address, network);
    if (cached?.symbol) {
      return cached.symbol;
    }
    
    const tokenContract = new ethers.Contract(address, ['function symbol() view returns (string)'], provider);
    const symbol = await fetchWithRetry(() => tokenContract.symbol());
    
    // Cache the result
    setCachedTokenData(address, network, { symbol });
    
    return symbol;
  } catch (error) {
    console.error('Error fetching token symbol:', error);
    return address.slice(0, 6) + '...' + address.slice(-4);
  }
};

// Enhanced token decimals fetching
export const fetchTokenDecimals = async (address, provider, network) => {
  try {
    // Check cache first
    const cached = getCachedTokenData(address, network);
    if (cached?.decimals !== undefined) {
      return cached.decimals;
    }
    
    const tokenContract = new ethers.Contract(address, ['function decimals() view returns (uint8)'], provider);
    const decimals = await fetchWithRetry(() => tokenContract.decimals());
    
    // Cache the result
    setCachedTokenData(address, network, { decimals });
    
    return decimals;
  } catch (error) {
    console.error('Error fetching token decimals:', error);
    return 18; // Default to 18 decimals
  }
};

// Enhanced lock data fetching
export const fetchLockData = async (contract, lockId) => {
  return await fetchWithRetry(async () => {
    const lock = await contract.locks(lockId);
    return {
      lockId,
      tokenAddress: lock.token,
      amount: lock.amount,
      unlockTime: lock.unlockTime,
      owner: lock.owner,
      withdrawn: lock.withdrawn
    };
  });
};

// Enhanced lock count fetching
export const fetchLockCount = async (contract) => {
  return await fetchWithRetry(async () => {
    return await contract.lockCount();
  });
};

// Enhanced user locks fetching
export const fetchUserLocks = async (contract, userAddress, includeWithdrawn = false) => {
  try {
    const lockCount = await fetchLockCount(contract);
    const userLocks = [];
    
    // Use Promise.all for parallel fetching with chunking to avoid rate limits
    const chunkSize = 10;
    for (let i = 0; i < lockCount; i += chunkSize) {
      const chunk = [];
      for (let j = 0; j < chunkSize && i + j < lockCount; j++) {
        chunk.push(fetchLockData(contract, i + j));
      }
      
      const chunkResults = await Promise.all(chunk);
      
      for (const lock of chunkResults) {
        if (lock.owner.toLowerCase() === userAddress.toLowerCase() && 
            (includeWithdrawn || !lock.withdrawn)) {
          userLocks.push(lock);
        }
      }
    }
    
    return userLocks;
  } catch (error) {
    console.error('Error fetching user locks:', error);
    throw error;
  }
};

// Ethereum injection handler
export const handleEthereumInjection = () => {
  try {
    if (window.ethereum) {
      console.log('Using existing ethereum provider');
    }
  } catch (error) {
    console.warn('Multiple wallet extensions detected. Using first available provider.');
  }
};

// Helper function to format unlock time
export const formatUnlockTime = (unlockTime) => {
  const date = new Date(unlockTime * 1000);
  return date.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

// Helper function to check if unlock is available
export const isUnlockAvailable = (unlockTime) => {
  return Date.now() / 1000 >= unlockTime;
};

// Helper function to get token symbol
export const getTokenSymbol = (address, tokens, currentNetwork, manualTokenInfo, lockTokenSymbolMap) => {
  address = address.toLowerCase();
  
  // Check owned tokens
  const owned = tokens.find(t => t.address.toLowerCase() === address);
  if (owned && owned.symbol) return owned.symbol + (owned.name ? ` (${owned.name})` : '');
  
  // Check popular tokens
  if (POPULAR_TOKENS[currentNetwork]) {
    const pop = POPULAR_TOKENS[currentNetwork].find(t => t.address.toLowerCase() === address);
    if (pop && pop.symbol) return pop.symbol + (pop.name ? ` (${pop.name})` : '');
  }
  
  // Check manual token info
  if (manualTokenInfo && manualTokenInfo.address.toLowerCase() === address && manualTokenInfo.symbol) {
    return manualTokenInfo.symbol + (manualTokenInfo.name ? ` (${manualTokenInfo.name})` : '');
  }
  
  // Check cache
  if (lockTokenSymbolMap[address]) return lockTokenSymbolMap[address];
  
  // Fallback: show shortened address
  return address.slice(0, 6) + '...' + address.slice(-4);
};

// Helper function to get token decimals
export const getTokenDecimals = (address, tokens, currentNetwork, manualTokenInfo, lockTokenDecimalsMap) => {
  address = address.toLowerCase();
  
  // Check owned tokens
  const owned = tokens.find(t => t.address.toLowerCase() === address);
  if (owned && owned.decimals !== undefined) return owned.decimals;
  
  // Check popular tokens
  if (POPULAR_TOKENS[currentNetwork]) {
    const pop = POPULAR_TOKENS[currentNetwork].find(t => t.address.toLowerCase() === address);
    if (pop && pop.decimals !== undefined) return pop.decimals;
  }
  
  // Check manual token info
  if (manualTokenInfo && manualTokenInfo.address.toLowerCase() === address && manualTokenInfo.decimals !== undefined) {
    return manualTokenInfo.decimals;
  }
  
  // Check cached decimals
  if (lockTokenDecimalsMap[address] !== undefined) return lockTokenDecimalsMap[address];
  
  // Default to 18 until fetched
  return 18;
};

// Platform fee management utilities
export const getPlatformFeeWallet = (network) => {
  return network === 'ethereum' ? PLATFORM_FEE_WALLET_ETH : PLATFORM_FEE_WALLET_BSC;
};

// Function to check platform fee wallet balance for a specific token
export const getPlatformFeeBalance = async (tokenAddress, network, provider) => {
  try {
    const platformWallet = getPlatformFeeWallet(network);
    const tokenContract = new ethers.Contract(
      tokenAddress,
      ['function balanceOf(address account) view returns (uint256)', 'function decimals() view returns (uint8)', 'function symbol() view returns (string)'],
      provider
    );
    
    const [balance, decimals, symbol] = await Promise.all([
      tokenContract.balanceOf(platformWallet),
      tokenContract.decimals(),
      tokenContract.symbol()
    ]);
    
    return {
      balance: balance.toString(),
      formattedBalance: ethers.utils.formatUnits(balance, decimals),
      decimals,
      symbol,
      wallet: platformWallet
    };
  } catch (error) {
    console.error('Error fetching platform fee balance:', error);
    throw error;
  }
};

// Function to transfer fees from platform wallet to another address
export const transferPlatformFees = async (tokenAddress, toAddress, amount, network, signer) => {
  try {
    const platformWallet = getPlatformFeeWallet(network);
    const tokenContract = new ethers.Contract(
      tokenAddress,
      ['function transfer(address to, uint256 amount) returns (bool)'],
      signer
    );
    
    // Note: This requires the signer to be the platform wallet owner
    const tx = await tokenContract.transfer(toAddress, amount);
    await tx.wait();
    
    return tx;
  } catch (error) {
    console.error('Error transferring platform fees:', error);
    throw error;
  }
};

// Fetch and cache token symbol
export const fetchAndCacheTokenSymbol = async (address, provider, setLockTokenSymbolMap) => {
  try {
    const tokenContract = new ethers.Contract(address, MINIMAL_ERC20_ABI, provider);
    const symbol = await tokenContract.symbol();
    const name = await tokenContract.name();
    setLockTokenSymbolMap(prev => ({ ...prev, [address]: symbol + (name ? ` (${name})` : '') }));
  } catch (error) {
    console.error('Error fetching token symbol:', error);
  }
};

// Fetch and cache token decimals
export const fetchAndCacheTokenDecimals = async (address, provider, setLockTokenDecimalsMap) => {
  try {
    const tokenContract = new ethers.Contract(address, MINIMAL_ERC20_ABI, provider);
    const decimals = await tokenContract.decimals();
    setLockTokenDecimalsMap(prev => ({ ...prev, [address]: decimals }));
  } catch (error) {
    console.error('Error fetching token decimals:', error);
  }
}; 